import axios from 'axios';
import { baseUrl } from '../services';
import { getIdentityToken } from '../../auth';
import { IMPERSONATION_HEADER } from '../../components/common/constants';
import { getImpersonatedUserId } from '../util';

const devInstance = axios.create({
  baseURL: baseUrl,
});

const getErrorPayload = (error) => {
  if (error?.code === 'ERR_NETWORK') {
    return { timeout: true };
  }

  return error?.response?.data ?? (error instanceof Error ? { message: error.message } : error);
};

/*
 * Identity Platform ID tokens expire, so retrieve a current token immediately
 * before every standalone developer-portal request. The SDK refreshes it when
 * necessary; the application never stores a second copy of the token.
 */
devInstance.interceptors.request.use(async (config) => {
  try {
    // Validate impersonation before fetching a token or sending the request.
    const impersonatedUserId = getImpersonatedUserId();
    const token = await getIdentityToken();
    config.headers = {
      ...config.headers,
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(impersonatedUserId ? { [IMPERSONATION_HEADER]: impersonatedUserId } : {}),
    };
    return config;
  } catch (error) {
    return Promise.reject(getErrorPayload(error));
  }
});

devInstance.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(getErrorPayload(error)),
);

export default devInstance;
